import {BridgeMethod} from "@hybird/core/bridge/core";
import {invoke} from "@hybird/core/bridge/hybirdBridge";

export class FlutterPdf extends BridgeMethod {

  constructor() {
    super();
  }

  pdfToImage({url, path, filename = "1.pdf"}) {
    return invoke("pdfToImage", {
      params: {
        url, filename, path
      }
    });
  }
}

export const flutterPdf = new FlutterPdf();